import PropTypes from 'prop-types';
import {
  Badge, Text, Group, ActionIcon,
} from '@mantine/core';
import { IconInfoCircle, IconArrowRight } from '@tabler/icons-react';
import classes from './processHeader.module.css';

const ProcessHeader = ({
  headerText,
  headerColor = 'var(--mantine-color-blue-4)',
  headerTextColor = 'white',
  subtitle,
  infoText,
  icon: Icon,
  showReturnButton = false,
  onReturn,
  children,
}) => {
  const handleReturn = () => {
    if (onReturn) {
      onReturn();
    }
  };

  return (
    <div className={classes.processHeader}>
      {/* Header using Badge */}
      <div className={classes.headerContainer}>
        <div className={classes.headerBadgeContainer}>
          <Group gap="lg" align="center">
            {showReturnButton && (
              <ActionIcon
                variant="light"
                size="lg"
                onClick={handleReturn}
                className={classes.returnButton}
                title="Return to previous page"
              >
                <IconArrowRight size={20} />
              </ActionIcon>
            )}
            <Badge
              size="xl"
              variant="filled"
              color={headerColor}
              className={classes.headerBadge}
              styles={{
                label: {
                  color: headerTextColor,
                },
              }}
            >
              <Group gap="xs" align="center">
                {Icon && <Icon size={20} className={classes.headerIcon} />}
                <span>{headerText}</span>
              </Group>
            </Badge>

          </Group>
        </div>

        {/* Subtitle in a box - right aligned */}
        {subtitle && (
          <div className={classes.subtitleContainer}>
            <Text className={classes.subtitle}>
              {subtitle}
            </Text>
          </div>
        )}

        {/* Information box with icon - right aligned */}
        {infoText && (
          <div className={classes.infoContainer}>
            <div className={classes.infoBox}>
              <IconInfoCircle size={16} className={classes.infoIcon} />
              <Text className={classes.infoText}>
                {infoText}
              </Text>
            </div>
          </div>
        )}

      </div>

      {/* Content area */}
      <div className={classes.content}>
        {children}
      </div>
    </div>
  );
};

ProcessHeader.propTypes = {
  headerText: PropTypes.string.isRequired,
  headerColor: PropTypes.string,
  headerTextColor: PropTypes.string,
  subtitle: PropTypes.string,
  infoText: PropTypes.string,
  icon: PropTypes.elementType,
  showReturnButton: PropTypes.bool,
  onReturn: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default ProcessHeader;
